import React from 'react';
import clsx from 'clsx';
import { getElementActualHeight } from '../../../../../../_metronic/assets/ts/_utils';

interface Props {
  title: React.ReactNode;
  headerToolbar?: React.ReactNode;
  headerToolbarBeforeSave?: boolean;
  haveHistory?: boolean;
  onHistory?: () => void;
  isEditable?: boolean;
  isDirty?: boolean;
  isSaving?: boolean;
  onSave?: () => void;
  onReset?: () => void;
  children: React.ReactNode;
  className?: {
    container?: string;
    toolbar?: string;
    body?: string;
  };
}

export default function EditableCardContainer({
  title,
  headerToolbar,
  headerToolbarBeforeSave = false,
  haveHistory = false,
  onHistory,
  isEditable,
  isDirty,
  isSaving = false,
  onSave,
  onReset,
  children,
  className,
}: Props) {
    const headerElement = document.getElementById('kt_header');
    const toolbarElement = document.getElementById('kt_toolbar');
    const topbarHeight =
        (headerElement ? getElementActualHeight(headerElement) : 0) +
        (toolbarElement ? getElementActualHeight(toolbarElement) : 0);

  return (
    <div
      className={clsx(
        'card mb-5 mb-xl-10 border',
        className?.container,
        isSaving && 'overlay overlay-block'
      )}
    >
      <div
        className='card-header align-items-center sticky-top bg-white z-index-1'
        style={{ top: `${topbarHeight}px` }}
      >
        <h4 className='my-2'>
          {title}
          {isDirty && (
            <span className='ms-3 badge badge-light-danger align-middle'>Unsaved Changes</span>
          )}
        </h4>
        <div className={clsx('card-toolbar', className?.toolbar ?? 'gap-4')}>
          {headerToolbarBeforeSave && headerToolbar}
          {haveHistory && (
            <button
              onClick={onHistory}
              disabled={isSaving}
              className={clsx(
                'btn btn-icon btn-sm btn-secondary d-inline-flex align-items-center justify-content-center'
              )}
              title='View History'
            >
              <i className='fa fa-history fs-4 lh-1 m-0 p-0'></i>
            </button>
          )}
          {isEditable && (
            <>
              <button
                onClick={onSave}
                disabled={!isDirty || isSaving}
                className={clsx('btn btn-sm btn-primary')}
                title='Save Changes'
              >
                {isSaving && <span className='spinner-border spinner-border-sm me-2'></span>}
                {isSaving ? 'Saving...' : 'Save'}
              </button>
            </>
          )}
          {!headerToolbarBeforeSave && headerToolbar}
        </div>
      </div>

      <div className={clsx('card-body p-0 overlay-wrapper', className?.body)}>{children}</div>

      {/* Loading overlay blocker */}
      {isSaving && <div className='overlay-layer bg-white bg-opacity-25 z-index-3'></div>}
    </div>
  );
}
